module.exports = __webpack_public_path__ + "static/media/honeycomb-thumbnail.1f136123.png";